<template>
  <v-container v-if="!isLoading">
    <v-row>
      <h1>Başvuru Bilgileri</h1>
    </v-row>
    <hr
      class="my-6"
      style="background-color: #e4e7ec; height: 1px; border: 0;"
    />
    <v-card style="padding: 16px; border-radius: 16px;">
      <div
        class="d-flex flex-column align-start"
        style="padding: 12px; gap: 12px;"
      >
        <div class="d-flex">
          <v-img
            :src="require('../../assets/icons/back.svg')"
            contain
            class="mr-2"
            style="width: 40px; height: 40px; cursor: pointer;"
            v-if="e6 > 1"
            @click="goToStep(e6 - 1)"
          />
          <h2>{{ steps.find((x) => x.step === e6).title }}</h2>
        </div>
        <v-divider />
      </div>
      <v-row>
        <v-col cols="3">
          <template v-for="(step, index) in steps">
            <v-stepper-step
              :key="'step-' + step.step"
              :complete="e6 > step.step"
              :step="step.stepStr"
              :class="[
                { 'active-step': e6 === step.step },
                { 'clickable-step': e6 > step.step },
                { 'disable-step': e6 !== step.step || isStepperDisabled },
                'custom-step',
              ]"
              @click="goToStep(step.step, step.key)"
              color="#039855"
            >
              {{ step.title }}
            </v-stepper-step>

            <v-divider
              v-if="index < steps.length - 1"
              :key="'divider-' + index"
              vertical
              :class="[
                'custom-divider',
                { 'completed-divider': e6 > step.step },
              ]"
            ></v-divider>
          </template>
        </v-col>

        <v-col cols="9">
          <v-stepper
            v-model="e6"
            vertical
            style="box-shadow: none;"
            color="primary"
          >
            <v-stepper-content
              v-for="step in steps"
              :key="step.step"
              :step="step.step"
              v-show="e6 === step.step"
            >
              <component
                v-if="step.step === e6"
                :is="step.component"
                :form-data="getFormData()"
                @update-form-data="updateFormData"
              />
              <div class="d-flex justify-end">
                <v-btn
                  class="submit-button"
                  color="#4F3CEF"
                  @click="goToNextStep(step.step)"
                  v-if="step.step < steps.length"
                  :disabled="isButtonDisabled"
                >
                  {{ step.step == steps.length - 1 ? 'Tamamla' : 'Devam Et' }}
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import CompanyInfoForm from './CompanyInfoForm.vue'
import BankInfoForm from './BankInfoForm.vue'
import UserInfoForm from './UserInfoForm.vue'
import StoreInfoForm from './StoreInfoForm.vue'
import UploadDocsForm from './UploadDocsForm.vue'
import FormApprove from './FormApprove.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ApplyMerchantForm',
  components: {
    CompanyInfoForm,
    BankInfoForm,
    UserInfoForm,
    StoreInfoForm,
    UploadDocsForm,
    FormApprove,
  },
  data: () => ({
    e6: 1,
    steps: [
      {
        step: 1,
        key: 'companyInfo',
        title: 'Şirket Bilgileri',
        component: 'CompanyInfoForm',
        stepStr: '01',
      },
      {
        step: 2,
        key: 'bankInfo',
        title: 'Banka Bilgileri',
        component: 'BankInfoForm',
        stepStr: '02',
      },
      {
        step: 3,
        key: 'userInfo',
        title: 'Kullanıcı Bilgileri',
        component: 'UserInfoForm',
        stepStr: '03',
      },
      {
        step: 4,
        key: 'storeInfo',
        title: 'Mağaza Bilgileri',
        component: 'StoreInfoForm',
        stepStr: '04',
      },
      {
        step: 5,
        key: 'uploadDocs',
        title: 'Evrak Yükleme',
        component: 'UploadDocsForm',
        stepStr: '05',
      },
      {
        step: 6,
        key: 'formApprove',
        title: 'Başvuru Onayı',
        component: 'FormApprove',
        stepStr: '06',
      },
    ],
    isButtonDisabled: true,
    isStepperDisabled: false,
    isLoading: true,
  }),
  computed: {
    ...mapGetters('applyMerchantForm', ['getFormData']),
  },
  methods: {
    ...mapActions('applyMerchantForm', [
      'saveFormData',
      'getMerchantApplicationDetailsByEmail',
    ]),
    updateFormData(stepKey, data) {
      this.saveFormData(data)
      this.isButtonDisabled = !this.stepValidCheck(stepKey)
    },
    goToNextStep(currentStepNumber) {
      if (currentStepNumber < this.steps.length) {
        this.e6 = currentStepNumber + 1
        const nextStepKey = this.steps.find(
          (x) => x.step == currentStepNumber + 1,
        ).key
        this.isButtonDisabled = !this.stepValidCheck(nextStepKey)
      }
    },
    goToStep(stepNumber, stepKey) {
      if (stepNumber <= this.e6) {
        this.e6 = stepNumber
        this.isButtonDisabled = !this.stepValidCheck(stepKey)
      }
    },
    fullNameCheck(value) {
      const parts = value
        .trim()
        .split(' ')
        .filter((part) => part.length > 0)
      return parts.length >= 2 && parts.every((part) => part.length >= 2)
    },

    stepValidCheck(stepKey) {
      const data = this.getFormData()
      let isValid = false
      if (stepKey == 'companyInfo') {
        isValid = !!(
          data.ownerName &&
          data.ownerName.trim() &&
          this.fullNameCheck(data.ownerName) &&
          data.companyTitle &&
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(data.companyMail)
        )
      }
      if (stepKey == 'bankInfo') {
        isValid = !!(
          data.iban &&
          data.iban.trim() &&
          data.accountName &&
          data.accountName.trim() &&
          data.bankName
        )
      }
      if (stepKey == 'userInfo') {
        isValid = !!(
          data.authorizedPerson &&
          data.authorizedPerson.trim() &&
          this.fullNameCheck(data.authorizedPerson) &&
          data.authorizedPersonTitle &&
          data.authorizedPersonTitle.trim() &&
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
            data.authorizedPersonMail,
          )
        )
      }
      if (stepKey == 'storeInfo') {
        isValid = !!(
          data.companyName &&
          data.companyName.trim() &&
          data.companyAddress &&
          data.companyAddress.trim() &&
          data.subscriptionType &&
          data.coffeeSizeType.length &&
          data.milkType.length
        )
      }
      if (stepKey == 'uploadDocs') {
        isValid =
          (!!data.taxPlate || !!data.taxPlateUrl) &&
          (!!data.certificateOfActivity || !!data.certificateOfActivityUrl) &&
          (!!data.signatureCircular || !!data.signatureCircularUrl) &&
          (!!data.tradeRegistryRecord || !!data.tradeRegistryRecordUrl) &&
          (!!data.contract || !!data.contractUrl)
      }
      return isValid
    },
  },
  mounted() {
    this.getMerchantApplicationDetailsByEmail().then((details) => {
      this.isLoading = false
      this.updateFormData('companyInfo', details)
      if (
        details.status == 'PendingApproval' ||
        details.status == 'AwaitingStoreOpening'
      ) {
        this.isStepperDisabled = true
        this.e6 = 6
      }
    })
  },
}
</script>

<style>
.clickable-step {
  cursor: pointer;
}
.custom-step {
  font-weight: 500;
}
.custom-step > span {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e4e7ec;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.active-step > span {
  border: 1px solid #e4e7ec;
  background-color: white;
}

.custom-divider {
  background-color: #e4e7ec;
  margin: -10px 45px;
  min-height: 40px;
}
.completed-divider {
  background-color: #1210ff !important;
}
.v-stepper__step--complete .theme--light.v-icon {
  color: white;
}
.disable-step {
  color: #98a2b3 !important;
}
.submit-button {
  color: white !important;
  width: 100%;
  text-transform: capitalize;
  height: 48px !important;
  border-radius: 32px;
  margin-top: 16px;
}
</style>
